import { Currency } from '@seapoint/server/enums';
import { AmountDisplay } from '../../../../design-system/amount-display/amount-display';
import { Stack } from '../../../../design-system/stack/stack';
import { cn } from '../../../../utils/cn';
import { exhaustiveCheck } from '../../../../utils/exhaustive-check';

export type MetricCardVariant = 'OUTSTANDING' | 'OVERDUE' | 'DUE_7_DAYS' | 'REVIEW_MATCHES';

type InvoicesMetricCardProps = {
  variant: MetricCardVariant;
  metric: number;
  normalizedAmount: number;
  currency: Currency;
};

export const InvoicesMetricCard = ({ metric, variant, normalizedAmount, currency }: InvoicesMetricCardProps) => {
  const label = getCardLabel(variant);

  return (
    <Stack space={5} className="flex-1 rounded-lg bg-seapoint-gray-background-modal px-7 py-5">
      <p
        className={cn('text-2xl font-semibold leading-6 tracking-tight text-black', {
          'text-seapoint-red': variant === 'OVERDUE',
        })}
      >
        {metric}
      </p>

      <Stack>
        <p className="text-sm font-medium text-black">{label}</p>

        <AmountDisplay
          normalizedAmount={normalizedAmount}
          currency={currency}
          isAccountBalance
          className="text-xs font-medium leading-6 tracking-tight text-seapoint-gray-text"
        />
      </Stack>
    </Stack>
  );
};

const getCardLabel = (variant: MetricCardVariant) => {
  switch (variant) {
    case 'OUTSTANDING':
      return 'Total outstanding';
    case 'OVERDUE':
      return 'Overdue';
    case 'DUE_7_DAYS':
      return 'Due next 7 days';
    case 'REVIEW_MATCHES':
      return 'Matches to review';
    default:
      return exhaustiveCheck(variant);
  }
};
